<style>
  div.tabs {
    grid-template-columns: 1fr 1fr 1fr 2fr; /* the last one is the remaining empty space */
  }

  div.tab {
    border-radius: 5px;
    margin-right: 10px;
  }

  div.tab .content {
    padding: 6px 0px;
  }

  @media screen and (width < 1200px) {
    div.tabs {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
</style>

<div class="containerMargins">
  <div class="tabs">
    <div class="tab" id="tab_accountContactsContainer">
      <div class="content" (click)="selectBookmark('accountContactsContainer')">
        Account Info
      </div>
    </div>
    <div class="tab" id="tab_accountBillingContainer">
      <div class="content" (click)="selectBookmark('accountBillingContainer')">
        Billing
      </div>
    </div>
    <div class="tab" id="tab_accountUsersContainer">
      <div class="content" (click)="selectBookmark('accountUsersContainer')">
        Users
      </div>
    </div>

    <!--
        <div class="tab" id="tab_contactInformationContainer">
            <div class="content " (click)="selectBookmark('contactInformationContainer')">
                Contact
            </div>
        </div>
        <div class="tab" id="tab_accountUsersContainer">
            <div class="content " (click)="selectBookmark('accountUsersContainer')">
                Users
            </div>
        </div>
        <div class="tab" id="tab_apiInformationContainer">
            <div class="content " (click)="selectBookmark('apiInformationContainer')">
                Settings
            </div>
        </div>
    -->
    <div class="endspace"></div>
  </div>
</div>

<div
  class="sectionContainer tabContent paddedContent containerMargins"
  style="border-top-left-radius: 0px"
  id="accountContactsContainer"
>
  <app-account-info-form
    [account]="account"
    [enableEditing]="allowEditContact"
    [mode]="FormMode.View"
    (saved)="handleSaved($event)"
  >
  </app-account-info-form>
</div>

<div
  class="sectionContainer tabContent paddedContent containerMargins"
  style="border-top-left-radius: 0px"
  id="accountBillingContainer"
>
  <app-account-billing-form
    [account]="this.account"
    [mode]="FormMode.View"
    [enableEditing]="allowEditBilling"
    (saved)="handleSaved($event)"
  >
  </app-account-billing-form>
</div>

<div
  class="sectionContainer tabContent paddedContent containerMargins"
  style="border-top-left-radius: 0px"
  id="accountUsersContainer"
>
  <app-account-users-form
    [accountId]="this.account.id"
    [enableEditing]="allowEditBilling"
    (saved)="handleSaved($event)"
  >
  </app-account-users-form>
</div>
